import {IFinanceOperations, IFinanceOperationsListItem, FinanceOperationsResponseType} from "@/entity/finance/finance_operations/financeOperations.types";

export default class FinanceOperations implements IFinanceOperations {
    total: number;
    data: IFinanceOperationsListItem[] = [];
    constructor(data: FinanceOperationsResponseType) {
        this.total = data.total;
        if(data && data.data){
            for (let i = 0; i < data.data.length; i++) {
                this.data.push(data.data[i]);
            }
        }
    }
}